export default __webpack_public_path__ + "static/media/yaroslavl_gusev.94675ede.jpg";